var dropdownCallback = function( mutationsList ) {

    mutationsList.forEach(mutation => {

        if ( mutation.type == 'attributes' ) {

            if (mutation.target.matches('[class*=uninav--show-]')) {
                const suggestPanel = document.getElementById('suggestPanel');

                if (suggestPanel) {

                    suggestPanel.style.display = 'none';

                }
            }
			
        }

        mutation.removedNodes.forEach( element => {

            if (mutation.target.matches('[class*=uninav--show-]')) {
                const suggestPanel = document.getElementById('suggestPanel');

                if (suggestPanel) {

                    suggestPanel.style.display = 'block';

                }
            }

        });
		
    });
};

export default dropdownCallback;

